import { BLACK_700, BLACK_800, BLACK_900, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var prefixAlignmentStyles = (prefixAlignment, level, isLargeScreen) => {
  if (level) {
    return {
      paddingRight: isLargeScreen ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_4
    };
  }
  return Object.assign(Object.assign({}, prefixAlignment === 'left' && {
    paddingRight: tokens.spacing.SPACING_8
  }), prefixAlignment === 'center' && {
    paddingHorizontal: tokens.spacing.SPACING_8
  });
};
export var getLevelPaddings = (alignmentLevel, isLargeScreen) => {
  if (!alignmentLevel) {
    return {};
  }
  return Object.assign(Object.assign(Object.assign({}, alignmentLevel === 'L1' && {
    paddingLeft: tokens.spacing.SPACING_0
  }), alignmentLevel === 'L2' && {
    paddingLeft: isLargeScreen ? tokens.spacing.SPACING_24 : tokens.spacing.SPACING_16
  }), alignmentLevel === 'L3' && {
    paddingLeft: isLargeScreen ? tokens.spacing.SPACING_48 : tokens.spacing.SPACING_32
  });
};
export var levelTextColorMap = {
  L1: BLACK_900,
  L2: BLACK_800,
  L3: BLACK_700,
  undefined: BLACK_700,
  null: BLACK_700
};
export var getListWidgetStyles = props => {
  var _props$leftSpacing = props.leftSpacing,
    leftSpacing = _props$leftSpacing === void 0 ? 0 : _props$leftSpacing,
    _props$topSpacing = props.topSpacing,
    topSpacing = _props$topSpacing === void 0 ? 0 : _props$topSpacing;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      paddingLeft: leftSpacing,
      paddingTop: topSpacing
    },
    ctaStyles: {
      marginTop: tokens === null || tokens === void 0 ? void 0 : tokens.spacing.SPACING_8
    },
    content: {
      flex: 1
    }
  });
};